import { useFormikContext } from 'formik'
import { useEffect, useRef } from 'react'
import { LotesFormData } from '../types'

export function TipoNegociacaoSubcontratadoListener() {
  const { values, setFieldValue } = useFormikContext<LotesFormData>()
  const previous = useRef(values.tipoNegociacaoSubcontratado)

  useEffect(() => {
    const current = values.tipoNegociacaoSubcontratado
    const wasMargem = previous.current === 'MARGEM'
    const isMargem = current === 'MARGEM'

    if (wasMargem !== isMargem) {
      values.pernas.forEach((_, index) => {
        setFieldValue(`pernas.${index}.freteSubcontratadoPJ`, '')
        setFieldValue(`pernas.${index}.freteSubcontratadoPF`, '')
      })
    }

    previous.current = current
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.tipoNegociacaoSubcontratado])

  return null
}
